import { PaymentMethod } from 'modules/purchase/constants'
import { eventLogger } from 'services/eventLogger.service'
import { ScreenName } from 'root-constants'
import { TProductId } from 'models/subscriptions.model'

export const logFailedPayPalPayment = ({
  productId,
  price,
  error,
  paymentMethod,
  currency,
  screenName,
  isTrialActive,
}: {
  productId: TProductId
  price: number
  error?: Record<string, undefined>
  paymentMethod: PaymentMethod
  currency: string
  screenName: ScreenName
  isTrialActive?: boolean
}): void => {
  eventLogger.logPurchaseFailed({
    productId,
    priceDetails: { price, currency, trial: isTrialActive },
    error: {
      type: error?.name || '',
      code: error?.debug_id,
      description: error?.message,
    },
    paymentMethod,
    screenName,
  })
}
